<base-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="btnOkClass" [btnOkLabel]="btnOkLabel" [isBtnOkActive]="message && errors.length === 0" (onOk)="ok()">
		<ng-content></ng-content>
		<label>{{question}}</label>
		
		<input
			type="text"
			class="form-control"
			[(ngModel)]="message"
			(input)="onChange.emit($event.target.value)"
			name="name"
		>
		
		<p *ngIf="errors.length > 0">
				<ngb-alert [dismissible]="false" [type]="'danger'">
					<ul>
						<li *ngFor="let error of errors">
							{{ error }}
						</li>
					</ul>
				</ngb-alert>
			</p>
	</base-modal>